import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';

const propTypes = {
  autoplay: PropTypes.bool,
  autoplayInterval: PropTypes.number,
  slide: PropTypes.number,
  slides: PropTypes.array.isRequired,
};

const defaultProps = {
  autoplay: false,
  autoplayInterval: 3000,
  slide: 0,
};

const PreviousSlideArrow = ({ slideCount, previousSlide }) => {
  if (slideCount > 1) {
    return (
      <span
        className="iconified-font iconified-chevron-left text-color-blue text-size-28 padding-xs-10 padding-md-20 clickable"
        onClick={previousSlide}
      />
    );
  }
  return null;
};

PreviousSlideArrow.propTypes = {
  slideCount: PropTypes.number,
  previousSlide: PropTypes.func,
};

PreviousSlideArrow.defaultProps = {
  slideCount: 0,
  previousSlide: () => {},
};

const NextSlideArrow = ({ slideCount, nextSlide }) => {
  if (slideCount > 1) {
    return (
      <span
        className="iconified-font iconified-chevron-right text-color-blue text-size-28 padding-xs-10 padding-md-20 clickable"
        onClick={nextSlide}
      />
    );
  }
  return null;
};

NextSlideArrow.propTypes = {
  slideCount: PropTypes.number,
  nextSlide: PropTypes.func,
};

NextSlideArrow.defaultProps = {
  slideCount: 0,
  nextSlide: () => {},
};

const DECORATORS = [
  {
    component: PreviousSlideArrow,
    position: 'CenterLeft',
  },
  {
    component: NextSlideArrow,
    position: 'CenterRight',
  },
];

const ArrowCarousel = ({ slides, slide, autoplay, autoplayInterval }) => (
  <Carousel
    decorators={DECORATORS}
    dragging={slides.length > 1}
    slideIndex={slide}
    wrapAround
    autoplay={autoplay}
    autoplayInterval={autoplayInterval}
  >
    {slides}
  </Carousel>
);

ArrowCarousel.propTypes = propTypes;
ArrowCarousel.defaultProps = defaultProps;

export default ArrowCarousel;
